import { NgModule, ModuleWithProviders, APP_INITIALIZER} from '@angular/core';
import { Store, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { State } from './state';
import { InternalsModule } from './internals/internals.module';

import {
    ReducersConfigurator,
    EffectsConfigurator,
    ReducersRepository,
    EffectsRepository
} from './internals/index';

export function createState(
    store: Store<any>,
    reducer: ReducersConfigurator,
    effects: EffectsConfigurator,
    reducersRepository: ReducersRepository,
    effectsRepository: EffectsRepository
): State {

    return new State(
        store,
        reducer,
        effects,
        reducersRepository,
        effectsRepository
    );
}


@NgModule({
    imports: [ InternalsModule ],
})
export class StateModule {

    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: StateModule,
            providers: [{
                provide: State,
                useFactory: createState,
                deps: [
                    Store,
                    ReducersConfigurator,
                    EffectsConfigurator,
                    ReducersRepository,
                    EffectsRepository
                ]
            }]
        };
    }

    public static forChild(): ModuleWithProviders {
        return {
            ngModule: StateModule,
            providers: []
        };
    }
}



